<template>
  <div class="address-exchange-read-modal">
    <modal-frame :showModalFlag="modalDisplay" v-on:backdropClickEvent="closeModal">
      <div class="modal-header">
        <h1>連絡先交換QR読取</h1>
        <img src="/images/close_icon.svg" @click="closeModal" />
      </div>
      <div class="modal-body">
        <qrcode-stream 
          v-if="modalDisplay" 
          :constraints="{ facingMode: 'environment' }" 
          :camera="camera" 
          @detect="decoded"
          />
      </div>
    </modal-frame>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import { mapActions } from 'vuex'

import ModalFrame from '@/components/common/ModalFrame.vue'

export default {
  name: 'AddressExchangeReadModal',


  components: {
    QrcodeStream,
    ModalFrame,
  },

  props: {
    addressCategory: Object,
    modalDisplay: Boolean,
  },

  emits: [
    'addressExchangeFinishedEvent',
    'addressExchangeFailedEvent',
    'closeModalEvent',
  ],

  data () {
    return {
      camera: 'off',
    }
  },

  watch: {
    modalDisplay: { handler: 'updateCameraState', immediate: true }
  },

  computed: {
    cameraMode () {
      if (this.showModal) {
        return 'environment'
      } else {
        return 'off'
      }
    }
  },

  methods: {
    ...mapActions({
      exchangeAddress: 'addressExchangeToken/exchange',
      fetchAddressBook: 'addressBook/fetch',
    }),

    updateCameraState () {
      if (this.modalDisplay) {
        this.camera = 'environment'
      } else {
        this.camera = 'off'
      }
    },

    decoded (decodedString) {
      console.log('QR DECODE COMPLETE:: ' + decodedString)
      console.log('return value: ' + decodedString[0].rawValue)
      if (decodedString[0] && decodedString[0].rawValue && decodedString[0].rawValue.match(/([0-9a-f]{8})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{12})/) ) {
        this.exchangeAddress({ addressCategoryID: this.addressCategory.id, token: decodedString[0].rawValue }).then(res => {
          console.log(res)
          if (res.success) {
            // result text create
            let resultMessage = '連絡先のQR読取りを完了しました。\n'
            if (res.own.exist) {
              resultMessage += '交換先にはすでにあなたの連絡先は登録済みでした。\n'
            }
            if (res.own.success) {
              resultMessage += '交換先にあなたの連絡先を登録しました。\n'
            }
            if (res.target.exist) {
              resultMessage += 'あなたの連絡帳にはすでに交換先は登録済みでした。\n'
            }
            if (res.target.success) {
              resultMessage += 'あなたの連絡帳に交換先を登録しました。\n'
            }
            // reload address
            this.fetchAddressBook()
            // emit
            this.$emit('addressExchangeFinishedEvent', resultMessage)
          }
        }).catch(error => {
          console.error(error)
          console.log(error.response.data)
          let errorMessage = '何らかの原因で連絡先交換できませんでした。システム管理者にお問い合わせください。'
          if (error.response.data && error.response.data.code) {
            if (error.response.data.code == 'SAMEUSER') {
              errorMessage = '自分のアドレス帳に自分自身を登録できません。'
            } else if (error.response.data.code == 'USED') {
              errorMessage = 'QRが利用済みです。一度QRを閉じて、再度QRを表示してから試してください。'
            } else if (error.response.data.code == 'SAVEERROR') {
              errorMessage = '連絡先の保存に失敗しました。サーバーの応答:' + error.response.data.message
            }
          }
          this.$emit('addressExchangeFailedEvent', errorMessage)
        })
      }
    },

    closeModal () {
      this.$emit('closeModalEvent')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';
@import '@/assets/css/mediaQuery.scss';
@import '@/assets/css/colorTable.scss';

.address-exchange-read-modal {
  margin: 0;
  .modal-header {
    display: flex;
    justify-content: space-between;
    padding: 15px;
    padding-bottom: 0;
    h1 {
      margin: 0;
      font-size: 22pt;
      font-weight: normal;
    }
    img {
      width: 26px;
    }
  }
  .modal-body {
    padding: 15px;
    // qrcode-stream {
    //   width: calc(100vw - 50px);
    //   height: calc(100vw - 50px);
    // }
  }
}
</style>